interface BusinessSectionProps {
  id: number;
  title: string;
  content: string;
  features: string[];
  footer: string;
  image: string;
  reverse: boolean;
}

export default function BusinessSection({
  title,
  content,
  features,
  footer,
  image,
  reverse
}: BusinessSectionProps) {
  return (
    <div className="py-20 md:py-24 px-6 md:px-20 bg-white odd:bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div
          className={`flex flex-col ${
            reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'
          } gap-12 items-center`}
        >
          {/* Image */}
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <img
                src={image}
                alt={title}
                className="w-full h-80 object-cover object-top"
              />
            </div>
          </div>

          {/* Content */}
          <div className="w-full lg:w-1/2">
            <h2 className="text-2xl md:text-3xl font-bold text-blue-900 mb-6 leading-tight">
              {title}
            </h2>
            <div className="text-base text-gray-700 leading-relaxed mb-4 whitespace-pre-line">
              {content}
            </div>
            
            {/* Features List */}
            <ul className="space-y-2 mb-4">
              {features.map((feature, index) => (
                <li key={index} className="flex items-start gap-3">
                  <i className="ri-check-line text-blue-600 text-xl mt-0.5 flex-shrink-0"></i>
                  <span className="text-gray-700">{feature}</span>
                </li>
              ))}
            </ul>
            
            <div className="text-base text-gray-700 leading-relaxed whitespace-pre-line">
              {footer}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
